import { Flex } from '@/components/Grid';
import { Link } from '@/components/Link';
import { Heading } from '@/components/Heading';
import { Text } from '@/components/Text';

type Props = {
  title: string;
};

export function ProfileDeactivated({ title }: Props) {
  return (
    <Flex dir="column" gap={4}>
      <Heading align="center">{title}</Heading>
      <Text align="center">
        Je profiel is momenteel gedeactiveerd.{' '}
        <Link to={{ type: 'profile_status' }} underline>
          Klik hier
        </Link>{' '}
        om je profiel te heractiveren.
      </Text>
    </Flex>
  );
}
